import { CSSProperties } from 'react'
import styled from '@emotion/styled/macro'

import { btnMaxSizes, flexCenter } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const iOSCodeInputStyle = {
  '--input-font-size': '1.75rem'
} as CSSProperties

const CodeVerificationContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: inherit;

  & > p {
    font-weight: 500;
  }

  & > .ui-code-verification-inputs {
    input {
      background-color: white;
      border: 1px solid lightgrey;
      color: black;
      font-family: monospace;
      font-size: 2rem;
      height: 50px;
      outline: none;
      padding: 4px;
      text-align: center;
      width: 42px;

      :not(:first-of-type) {
        margin-left: 4px;
      }

      :focus {
        border-color: var(--celeste);
      }

      ${mediaQuery('mobile')} {
        font-size: var(--input-font-size, 2rem);
        height: 38px;
        width: 30px;
      }
    }

    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }

    &.with-errors {
      input {
        border: 1px solid var(--danger);
      }
    }
  }
`

const CodeVerificationNotes = styled('span')`
  font-size: 0.7rem;
  font-weight: 300;
  margin-top: 10px;
`

const CodeVerifyWithinInfo = styled('section')`
  font-size: 12px;
  font-weight: 400;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  opacity: 0.7;
`

const CodeVerificationSend = styled('span')`
  font-size: 0.8rem;
  margin-top: 16px;

  > span {
    color: var(--skydiver);
    cursor: pointer;

    :hover {
      text-decoration: underline;
    }
  }
`

const CodeVerificationSubmit = styled('div')`
  ${flexCenter}

  height: auto;

  > button {
    ${btnMaxSizes}

    margin-top: 32px;
  }
`

export {
  CodeVerificationContainer,
  CodeVerificationNotes,
  CodeVerificationSend,
  CodeVerificationSubmit,
  iOSCodeInputStyle,
  CodeVerifyWithinInfo
}
